import { EventType } from "../../types";

export function EventGroup({ title, events }: { title: string; events: EventType[] }) {
  if (!events.length) return null;

  return (
    <section className="event-group">
      <h2>{title}</h2>
      <div className="public-event-grid">
        {events.map((event) => (
          <a className="public-event-card" href={`/book/${event.id}`} key={event.id}>
            <span className="event-dot" style={{ background: event.color }} />
            <div>
              <strong>{event.title}</strong>
              <p>{event.description || "Та цаг захиалахдаа E-Mail болон утасны дугаараа зөв оруулна уу."}</p>
            </div>
            <span className="event-arrow">▶</span>
          </a>
        ))}
      </div>
    </section>
  );
}
